module.exports = __webpack_public_path__ + "img/hp-v3.6123045d.svg";